export default __webpack_public_path__ + "static/media/logo.ef8f9bcb.png";